import { apolloClient } from "../main";
import { GET_DEPARTMENTS } from "./gql-toolbox/queries";

const actions = {
  setDepartments: ({ commit }) => {
    apolloClient
      .query({
        query: GET_DEPARTMENTS
      })
      .then(data => {
        console.log(data);
      })
      .catch(err => {
        console.log(err);
      });
  }
};

export default actions;
